import cn from "classnames";
import { ReactNode } from "react";

// The tag palette (server: services/agencyDocuments/tagging.ts TAG_COLORS).
// Saturated 500/600 solids with white text read the same in both themes,
// so no dark: twins are needed (CLAUDE.md, colored solids rule).
export const TAG_COLOR_CLASSES: Record<string, string> = {
  blue: "bg-blue-500 text-white",
  emerald: "bg-emerald-600 text-white",
  amber: "bg-amber-500 text-white",
  rose: "bg-rose-500 text-white",
  violet: "bg-violet-500 text-white",
  cyan: "bg-cyan-600 text-white",
  orange: "bg-orange-500 text-white",
  teal: "bg-teal-600 text-white",
};

export const TAG_COLOR_DOTS: Record<string, string> = {
  blue: "bg-blue-500",
  emerald: "bg-emerald-600",
  amber: "bg-amber-500",
  rose: "bg-rose-500",
  violet: "bg-violet-500",
  cyan: "bg-cyan-600",
  orange: "bg-orange-500",
  teal: "bg-teal-600",
};

export const TAG_COLOR_NAMES = Object.keys(TAG_COLOR_CLASSES);

export function tagColorClass(color: string | null | undefined): string {
  return TAG_COLOR_CLASSES[color || ""] || "bg-base-300 text-base-content";
}

export const TagChip: React.FC<{
  name: string;
  color?: string | null;
  // Auto tags are dotted so an admin can tell them from ones a person set.
  auto?: boolean;
  count?: number;
  title?: string;
  onRemove?: () => void;
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
}> = ({ name, color, auto, count, title, onRemove, onClick, className, children }) => (
  <span
    title={title}
    onClick={onClick}
    className={cn(
      "inline-flex items-center gap-1 max-w-full rounded-full px-2 py-0.5 text-[11px] font-medium leading-4 whitespace-nowrap",
      tagColorClass(color),
      auto && "ring-1 ring-inset ring-white/60 border border-dashed border-white/70",
      onClick && "cursor-pointer hover:opacity-90",
      className
    )}
  >
    <span className="truncate">{name}</span>
    {count != null && <span className="opacity-80 tabular-nums">{count}</span>}
    {children}
    {onRemove && (
      <button
        type="button"
        className="ml-0.5 -mr-0.5 rounded-full px-1 leading-none opacity-80 hover:opacity-100 hover:bg-black/15"
        title="Remove tag"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        ×
      </button>
    )}
  </span>
);
